import { useEffect, useRef } from "react";
import { Capacitor } from "@capacitor/core";
import { App as CapacitorApp } from "@capacitor/app";

// Bouton retour materiel d'Android. Sans listener, Capacitor laisse le
// comportement par defaut : l'app se ferme d'un coup, meme depuis une fiche
// ouverte au fond d'un set. `handler` doit renvoyer true s'il a consomme le
// retour ; false = plus rien a fermer, on quitte pour de bon.
// No-op complet sur le web (meme esprit que appUpdater.js).
export function useAndroidBackButton(handler) {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    let listener;
    let cancelled = false;
    CapacitorApp.addListener("backButton", () => {
      if (!handlerRef.current()) CapacitorApp.exitApp();
    }).then(h => {
      if (cancelled) h.remove();
      else listener = h;
    });

    return () => { cancelled = true; listener?.remove(); };
  }, []);
}
